import React from 'react'
import WeddingSection from './WeddingSection'
import SendWeddingWish from 'components/SendWeddingWish'
import ShowWeddingWishList from 'components/ShowWeddingWishList'

export default function FormSection({ invitation }) {
    return <WeddingSection>
        <div className='no-wedding-padding-x no-wedding-padding-y' style={{
            position: "relative",
        }}>
            <img alt='' className='float-up-down' src='/img/flower_bg_pattern2.png' style={{
                position: "absolute",
                width: 100,
                bottom: 0,
                left: 0,
            }}/>
            <img alt='' className='float-up-down' src='/img/flower_bg_pattern.png' style={{
                position: "absolute",
                width: 150,
                top: 0,
                right: 0,
            }}/>
            <div style={{
                paddingLeft: 15, paddingRight: 15,
            }}>
                <SendWeddingWish confirmJoin={Boolean(invitation)} invitation={invitation}/>
                <ShowWeddingWishList />
            </div>
        </div>
    </WeddingSection>
}
